import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {closeFilterSpotsForm} from '../../actions/navOptions';
import {setAllFilterOptions, clearFilters} from '../../actions/filters';
import {groupParkingSpotsByFeaturesIfRequired} from '../../actions/parkingSpots';
import Filters from './Filters';
import FilterSpotsFooter from './FilterSpotsFooter';

class SearchSpotForm extends Component {

  componentWillMount() {
    this.props.groupParkingSpotsByFeaturesIfRequired();
  }

  componentDidMount() {
    this.props.setAllFilterOptions();
  }

  render() {
    const {closeFilterSpotsForm, filterOptions, appliedFilters} = this.props;

    return (
      <div className="map-page map-page__default">
        <div className="map-page-content" id="page-search" >
          <div className="map-page-content-head clearfix">
            <h2 className="pull-left"><div className="icon-search" />
              Filter spots
            </h2>
            <a href="#" className="close-it hide-map-page pull-right" onClick={closeFilterSpotsForm}>&times;</a>
          </div>

          <div className="map-page-body">
            <form action="">

              <Filters filterOptions={filterOptions.surface} appliedFilters={appliedFilters.surface} entity="surface" />
              <Filters filterOptions={filterOptions.sizes} appliedFilters={appliedFilters.sizes} entity="sizes" />

              <div className="form-group">
                <a href="#" onClick={this.props.clearFilters}>
                  <i className="fa fa-trash-o" />&nbsp;Clear filters
                </a>
              </div>

            </form>
          </div>

          <FilterSpotsFooter />

        </div>
      </div>
    );
  }

}


const mapStateToProps = (state) => {
  return {
    filterOptions: state.search.filterOptions,
    appliedFilters: state.search.appliedFilters
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ closeFilterSpotsForm, setAllFilterOptions, clearFilters, groupParkingSpotsByFeaturesIfRequired }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchSpotForm);



// WEBPACK FOOTER //
// ./src/containers/Search/SearchSpotForm.js